"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropListItemParent = void 0;
var React = require("react");
var react_popper_1 = require("react-popper");
var __1 = require("../..");
var _Core_1 = require("../../_Core");
var Icon_1 = require("../../Icons/Icon/Icon");
var Theme_1 = require("../../Theme");
var DropList_1 = require("./DropList");
var DropList_styles_1 = require("./DropList.styles");
var DropListItemParent = /** @class */ (function (_super) {
    __extends(DropListItemParent, _super);
    function DropListItemParent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { Visible: false };
        _this.handleCheckBoxClick = function (e) {
            e.stopPropagation();
            _this.props.OnCheckboxClick(e.target.checked);
        };
        _this.handleCloseMenu = function () {
            _this.setState({ Visible: false }, function () { return _this.LinkRow.focus(); });
            if (_this.props.OnCloseMenu) {
                _this.props.OnCloseMenu();
            }
        };
        _this.handleConfirmClick = function () {
            _this.setState({ Visible: false }, function () { return _this.LinkRow.focus(); });
            if (_this.props.OnConfirmClick) {
                _this.props.OnConfirmClick();
            }
        };
        _this.handleLinkClick = function (e) {
            e.stopPropagation();
            _this.setState({ Visible: true });
        };
        return _this;
    }
    DropListItemParent.prototype.render = function () {
        var _this = this;
        return (React.createElement(DropList_styles_1.MenuRow, { role: "none" },
            React.createElement(react_popper_1.Manager, null,
                React.createElement(react_popper_1.Reference, null, function (_a) {
                    var ref = _a.ref;
                    return (React.createElement(DropList_styles_1.ItemButton, { ref: function (e) {
                            if (typeof ref === "function") {
                                ref(e);
                            }
                            _this.LinkRow = e;
                        }, role: "menuitem", "aria-haspopup": true, onClick: _this.handleLinkClick, tabIndex: -1 },
                        _this.props.Icon && React.createElement(DropList_styles_1.IconBlock, null,
                            React.createElement(Icon_1.Icon, { Icon: _this.props.Icon, Height: "24px", Width: "24px" })),
                        _this.props.ShowCheckbox && React.createElement(DropList_styles_1.IconBlock, null,
                            React.createElement("input", { onClick: _this.handleCheckBoxClick, type: "checkbox", defaultChecked: _this.props.CheckboxValue, tabIndex: -1 })),
                        React.createElement(DropList_styles_1.Caption, null, _this.props.Caption),
                        React.createElement(DropList_styles_1.IconBlock, null,
                            React.createElement(Icon_1.Icon, { Icon: _Core_1.Icons.CaretRight, Height: "24px", Width: "24px" }))));
                }),
                this.state.Visible && (React.createElement(__1.Modal, { DisableAutoFocus: true },
                    React.createElement(react_popper_1.Popper, { placement: "right-start", strategy: "fixed", modifiers: [{ name: "preventOverflow", options: { boundary: document.querySelector("html") } }, { name: "flip", data: { behavior: "flip" } }] }, function (_a) {
                        var ref = _a.ref, style = _a.style, placement = _a.placement;
                        return (React.createElement(DropList_1.DropList, { ref: ref, Style: __assign(__assign({}, style), { zIndex: Theme_1.portalsZIndex }), Placement: placement, ConfirmCaption: _this.props.ConfirmCaption, OnConfirmClick: _this.handleConfirmClick, OnSearch: _this.props.OnSearch, OnSearchCancel: _this.props.OnSearchCancel, SearchAriaLabel: _this.props.SearchAriaLabel, ShowSearch: _this.props.ShowSearch, ShowConfirm: _this.props.ShowConfirm, OnCloseMenu: _this.handleCloseMenu, MaxHeight: _this.props.MaxHeight }, _this.props.children));
                    }))))));
    };
    return DropListItemParent;
}(React.PureComponent));
exports.DropListItemParent = DropListItemParent;
